module.exports = __webpack_public_path__ + "static/media/ic_show_alerts.a09c836c.svg";